module.exports = __webpack_public_path__ + "img/energy_icon5.c31826be.png";